import { DOCUMENT, inject, LOCALE_ID, NgModule } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { MAT_DATE_LOCALE } from '@angular/material/core';

registerLocaleData(localeIt);
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgChartsModule } from 'ng2-charts';
import { setContext } from '@apollo/client/link/context';
import { GraphQLLoggerLink } from './shared/libs/interceptors/graphql-logger.link';

import { AppComponent } from './app.component';
import { AppRouting } from './app.routing';
import { CoreModule } from './shared/core.module';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { httpErrorsInterceptor } from './shared/libs/interceptors/http-errors.interceptor';
import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache } from '@apollo/client/core';
import { AppService } from './app.service';
import { UiAvatarImageComponent } from './shared/libs/up-header/ui-avatar/ui-avatar-image.component';
import { UpTopHeaderComponent } from './shared/libs/up-header/up-top-header/up-top-header.component';
import { ContextService } from './shared/libs/services/context.service';
import { environment } from '../environments/environment';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { AuthComponent } from './shared/components/auth/auth.component';
import { CommonModule } from '@angular/common';
import { AuthService } from './shared/libs/auth/auth.service';
import { SharedModule } from './shared/shared.module';
@NgModule({
	declarations: [AppComponent, AuthComponent],
	imports: [
		BrowserModule,
		AppRouting,
		NgChartsModule,
		BrowserAnimationsModule,
		CoreModule.forRoot(),
		UiAvatarImageComponent,
		UpTopHeaderComponent,
		MatIconModule,
		MatBadgeModule,
		CommonModule,
		SharedModule
	],
	providers: [
		{ provide: LOCALE_ID, useValue: 'it-IT' },
		{ provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
		provideHttpClient(withInterceptors([httpErrorsInterceptor])),
		provideApollo(() => {
			const httpLink = inject(HttpLink);
			const appService = inject(AppService);
			const authService = inject(AuthService);

			const uri = `${appService.utilsUrls.baseUrl}/api/graphql`;

			const authLink = setContext((operation, prevContext) => {
				const token = authService.getTokenValue;

				return {
					headers: {
						...prevContext.headers,
						...(token ? { Authorization: `Bearer ${token}` } : {})
					}
				};
			});

			const http = httpLink.create({ uri });
			const loggerLink = new GraphQLLoggerLink();

			return {
				link: loggerLink.concat(authLink.concat(http)),
				cache: new InMemoryCache()
			};
		})
	],
	bootstrap: [AppComponent]
})
export class AppModule {
	readonly #contextService = inject(ContextService);
	constructor() {
		this.initContext();
	}

	private initContext() {
		const documentRef = inject(DOCUMENT);
		const baseHref = documentRef.getElementsByTagName('base')[0].href;
		environment.frontendUrl = baseHref.slice(0, -1);

		if (environment.auth) {
			this.#contextService.context.Environment = environment.auth;
			this.#contextService.context.Settings.AppPaths.Core = {
				Base: environment.auth.protocol + '://accounts' + environment.auth.urlPart + '.basic.net',
				Api: environment.auth.protocol + '://accounts' + environment.auth.urlPart + '.basic.net'
			};

			this.#contextService.context.Settings.AppPaths.Local = {
				Base: environment.frontendUrl
			};

			this.#contextService.context.Settings.AppPaths.Global = {
				Api: environment.auth.protocol + '://globalapi' + environment.auth.urlPart + '.basic.net'
			};

			this.#contextService.context.Settings.AppPaths.BasicApp = {
				Base: environment.auth.protocol + '://basicapp' + environment.auth.urlPart + '.basic.net'
			};

			this.#contextService.context.Settings.AppPaths.BasicNet = {
				Base: environment.auth.protocol + '://my' + environment.auth.urlPart + '.basic.net',
				Api: environment.auth.protocol + '://my-api' + environment.auth.urlPart + '.basic.net'
			};

			this.#contextService.context.Settings.LoginUrl = this.#contextService.context.Settings.AppPaths.Core.Base + '/account/login';
			this.#contextService.context.Settings.LogoffUrl = this.#contextService.context.Settings.AppPaths.Core.Base + '/account/clientlogoff';
		}
	}
}
